export default class DisclosurePanelBehaviour {
  static id = 'disclosure-panel';

  constructor(node) {
    this.node = node;
    this.triggerNode = document.querySelector('[data-ref="disclosure-trigger"]');
    this.contentNode = document.querySelector('[data-ref="disclosure-content"]');

    this.triggerNode.addEventListener('click', this.handleClickTrigger);
  }

  handleClickTrigger = () => {
    const open = this.node.getAttribute('aria-expanded') === 'true';
    if (open) {
      this.animateClose();
    } else {
      this.animateOpen();
    }
  };

  animateClose = () => {
    requestAnimationFrame(() => {
      const contentHeight = this.contentNode.scrollHeight;
      this.contentNode.style.height = `${contentHeight}px`;
      requestAnimationFrame(() => {
        this.contentNode.style.height = '0px';
      });
    });

    this.node.setAttribute('aria-expanded', 'false');
  };

  animateOpen = () => {
    const contentHeight = this.contentNode.scrollHeight;
    this.contentNode.style.height = `${contentHeight}px`;

    this.node.setAttribute('aria-expanded', 'true');

    this.contentNode.addEventListener('transitionend', this.handleTransEnd);
  };

  handleTransEnd = () => {
    this.contentNode.style.height = 'auto';
    this.contentNode.removeEventListener('transitionend', this.handleTransEnd);
  };
}
